import {
  FEATURES,
  OOREDOO_OFFER,
  AIRALO_OFFER,
  DS_QUOTE,
  SELECT_PLAN_INSURANCE_VALUES,
  GEORGIA_WINTER_COVER,
  INSURED_TRAVELERS_QC,
  PERSONAL_INFORMATION_QC,
  INBOUND_SELECT_PLAN_QC,
  CONTACTS_QC,
  TRAVELERS_QC,
  DATES_QC,
  FIRST_STEP_QC,
  PROGRESS_BAR_QC,
} from '@/shared/constants/features.constants'
import { initializeApp } from 'firebase/app'
import {
  fetchAndActivate,
  getRemoteConfig,
  getValue,
  setCustomSignals,
} from 'firebase/remote-config'
import { defineStore } from 'pinia'

const FIREBASE_CONFIG = {
  apiKey: import.meta.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: 'fb-web-qic.firebaseapp.com',
  projectId: 'fb-web-qic',
  storageBucket: 'fb-web-qic.firebasestorage.app',
  messagingSenderId: '76324519272',
  appId: '1:76324519272:web:c57028814ebaf5048f2add',
  measurementId: 'G-WFKYGFJCF9',
}

export const useFeaturesStore = defineStore('featuresStore', {
  state: () => ({
    features: {} as Record<string, boolean>,
    isAiralooEnabled: false,
    isOoredooEnabled: false,
    isDsQuoteEnabled: false,
    isSelectPlanInsuranceValuesEnabled: false,
    isGeorgiaWinterCoverEnabled: false,
    isInsuredTravelersQcEnabled: false,
    isPersonalInformationQcEnabled: false,
    isSelectPlanInboundQCEnabled: false,
    isContactsQcEnabled: false,
    isTravelersQcEnabled: false,
    isDatesQcEnabled: false,
    isFirstStepQcEnabled: false,
    isProgressBarQcEnabled: false,
  }),
  getters: {
    getFeatureValue:
      (state) =>
      (feature: string): boolean =>
        state.features[feature] || false,
  },
  actions: {
    async fetchRemoteConfig() {
      try {
        const app = initializeApp(FIREBASE_CONFIG)
        const remoteConfig = getRemoteConfig(app)
        remoteConfig.settings.minimumFetchIntervalMillis = 3600000

        try {
          await setCustomSignals(remoteConfig, {
            env: process.env.NODE_ENV === 'production' ? window.location.hostname : 'dev',
          })
        } catch (error) {
          console.error('Error setting custom signals:', error)
        }

        await fetchAndActivate(remoteConfig)
        FEATURES.forEach((feature: string) => {
          this.features[feature] = getValue(remoteConfig, feature).asBoolean()
        })
        this.setIsAiralooEnabled()
        this.setIsOoredooEnabled()
        this.setIsDsQuoteEnabled()
        this.setIsSelectPlanInsuranceValuesEnabled()
        this.setIsGeorgiaWinterCoverEnabled()
        this.setIsInsuredTravelersQcEnabled()
        this.setIsPersonalInformationQcEnabled()
        this.setIsSelectPlanInboundQCEnabled()
        this.setIsContactsQcEnabled()
        this.setIsTravelersQcEnabled()
        this.setIsDatesQcEnabled()
        this.setIsFirstStepQcEnabled()
        this.setIsProgressBarQcEnabled()
      } catch (error) {
        console.error('Error loading Remote Config:', error)
      }
    },
    setIsAiralooEnabled() {
      this.isAiralooEnabled = this.getFeatureValue(AIRALO_OFFER) || false
    },
    setIsOoredooEnabled() {
      this.isOoredooEnabled = this.getFeatureValue(OOREDOO_OFFER) || false
    },
    setIsDsQuoteEnabled() {
      this.isDsQuoteEnabled = this.getFeatureValue(DS_QUOTE) || false
    },
    setIsSelectPlanInsuranceValuesEnabled() {
      this.isSelectPlanInsuranceValuesEnabled =
        this.getFeatureValue(SELECT_PLAN_INSURANCE_VALUES) || false
    },
    setIsGeorgiaWinterCoverEnabled() {
      this.isGeorgiaWinterCoverEnabled = this.getFeatureValue(GEORGIA_WINTER_COVER) || false
    },
    setIsInsuredTravelersQcEnabled() {
      this.isInsuredTravelersQcEnabled = this.getFeatureValue(INSURED_TRAVELERS_QC) || false
    },
    setIsPersonalInformationQcEnabled() {
      this.isPersonalInformationQcEnabled = this.getFeatureValue(PERSONAL_INFORMATION_QC) || false
    },
    setIsSelectPlanInboundQCEnabled() {
      this.isSelectPlanInboundQCEnabled = this.getFeatureValue(INBOUND_SELECT_PLAN_QC) || false
    },
    setIsContactsQcEnabled() {
      this.isContactsQcEnabled = this.getFeatureValue(CONTACTS_QC) || false
    },
    setIsTravelersQcEnabled() {
      this.isTravelersQcEnabled = this.getFeatureValue(TRAVELERS_QC) || false
    },
    setIsDatesQcEnabled() {
      this.isDatesQcEnabled = this.getFeatureValue(DATES_QC) || false
    },
    setIsFirstStepQcEnabled() {
      this.isFirstStepQcEnabled = this.getFeatureValue(FIRST_STEP_QC) || false
    },
    setIsProgressBarQcEnabled() {
      this.isProgressBarQcEnabled = this.getFeatureValue(PROGRESS_BAR_QC) || false
    },
  },
})
